import type { ImportResult } from '@ais-ui/api';

export type VesselTrack = ImportResult['tracks'][number];

/** A track is stationary when every reported waypoint has a speed of 0 knots. */
export const isStationaryTrack = (track: VesselTrack): boolean =>
  track.waypoints.length > 0 &&
  track.waypoints.every((waypoint) => waypoint.sog_kn === 0);
